module.exports = __webpack_public_path__ + "img/1538559454.8036d3f5.jpg";